export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:4600/api/v1',
  TIMEOUT: 30000,
} as const;

export const API_ENDPOINTS = {
  AUTH: {
    SIGNIN: '/auth/signin',
    REFRESH_TOKEN: '/auth/refresh-token',
    LOGOUT: '/auth/logout',
  },
  USER: { ME: '/user/me' },
  ADMIN: {
    METRICS: '/admin/metrics/overview',
    USERS: '/admin/users',
    USER: (id: string) => `/admin/users/${id}`,
    SUSPENSION: (id: string) => `/admin/users/${id}/suspension`,
    RESTORE: (id: string) => `/admin/users/${id}/restore`,
    PERMANENT: (id: string) => `/admin/users/${id}/permanent`,
    SUBSCRIPTIONS: '/admin/subscriptions',
    PAYMENTS: '/admin/payments',
    SWEEP_ORPHANS: '/admin/maintenance/sweep-orphans',
  },
} as const;

export const ROUTES = {
  LOGIN: '/login',
  OVERVIEW: '/',
  USERS: '/users',
  USER_DETAIL: (id: string) => `/users/${id}`,
  BILLING: '/billing',
} as const;
